export function checkIfUrl(profileInformation) {
    const urlRegex = /[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi;
    const result = urlRegex.test(profileInformation);
    return result;
}

export default checkIfUrl;
